import { Component } from '@angular/core';
import { OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ReProjectsService } from 'src/app/features/re-projects/services/re-projects.service';
import { CommunityService } from 'src/app/features/community/services/community/community.service';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { extractErrorMessage } from 'src/app/core/services/uitls/error.util';
import * as moment from 'moment';

@Component({
    selector: 'app-community-details',
    templateUrl: './community-details.component.html',
    styleUrls: ['./community-details.component.scss'],
    standalone: false
})
export class CommunityDetailsComponent implements OnInit {

  title: string = 'إضافة مجتمع';
  titleDescription: string = '';
  communityId: number | null = null;
  communityFormGroup: FormGroup = new FormGroup({});
  isActive: boolean = true;
  reProjects: any[] = [];
  reProjectsPageCount: any;
  reProjectsPage: number = 1;
  reProjectSearchInput!: string;
  @ViewChild('selectreproject') selectreproject!: NgSelectComponent;
  reProjectSearchTimeout: ReturnType<typeof setTimeout> | undefined;
  errorMsg: boolean = false;
  message: string = '';
  saveDialogRef!: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private reProjectsService: ReProjectsService,
    private communityService: CommunityService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.title = 'تعديل مجتمع';
        this.communityId = +params['id'];
        this.getCommunityDetails();
      } else {
        this.title = 'إضافة مجتمع';
        this.titleDescription = 'عرّف كوهورت الندوة واربطه بمشروع عقاري.';
      }
    });
    this.getREProjects();
    this.createCommunityFormGroup();
  }

  createCommunityFormGroup(): void {
    const urlPattern = /^(https?:\/\/)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
    
    this.communityFormGroup = this.formBuilder.group({
      is_active: [true],
      title: ['', Validators.required],
      description: [''], // missing
      code: ['', Validators.required],
      project: [null, Validators.required],
      registration_form_link: ['', Validators.pattern(urlPattern)],
      survey_form_link: ['', Validators.pattern(urlPattern)],
      webinar_title: [''],
      webinar_link: ['', Validators.pattern(urlPattern)],
      webinar_date: [null],
      webinar_time: [null],
    });
  }

  getCommunityDetails() {
    if (this.communityId) {
      this.communityService.getCommunity(this.communityId).subscribe((data) => {
        const communityData = data.data;
        this.communityFormGroup.patchValue(communityData);
        this.communityFormGroup.get('project')?.setValue(communityData.project?.id || null);
        this.isActive = communityData.is_active;
      });
    }
  }

  getREProjects() {
    const params: any = { page: this.reProjectsPage, page_size: 20 };
    if (this.reProjectSearchInput) {
      params['query'] = this.reProjectSearchInput;
    }
    this.reProjectsService.getREProjects(params).subscribe((data) => {
      if (this.reProjectsPage === 1) {
        this.reProjects = data.data || [];
      } else {
        this.reProjects.push(...(data.data || []));
      }
      this.reProjectsPageCount = data.pages_count;
    });
  }

  resetREProjectSearch() {
    this.reProjects = [];
    this.reProjectsPage = 1;
    this.reProjectSearchInput = '';
    this.getREProjects();
  }

  onScrollREProjectPagination() {
    if (this.reProjectsPage < this.reProjectsPageCount) {
      this.reProjectsPage++;
      this.getREProjects();
    }
  }

  searchREProjectText() {
    this.reProjectSearchInput = this.selectreproject.searchTerm;
    this.reProjects = [];
    this.reProjectsPage = 1;
    clearTimeout(this.reProjectSearchTimeout);
    let that = this;
    that.reProjectSearchTimeout = setTimeout(() => {
      if (that.reProjectSearchInput != '') {
        that.getREProjects();
      } else {
        that.reProjectsPage = 1;
        that.getREProjects();
      }
    }, 600);
  }

  goBack() {
    this.router.navigate(['pages/community']);
  }

  formatDate(): string {
    const formattedDate = moment(
      this.communityFormGroup.get('webinar_date')?.value
    );
    const formattedDateString = formattedDate.format('YYYY-MM-DD');
    return formattedDateString;
  }

  payloadWithFormattedDate(): any {
    const payload = { ...this.communityFormGroup.value };
    if (payload.webinar_date) {
      payload.webinar_date = this.formatDate();
    }
    return payload;
  }

  save(event: any) {
    if (this.communityFormGroup.invalid) {
      this.errorMsg = true;
      this.message = 'برجاء تعبئة  جميع الخانات الضرورية بشكل صحيح';
      this.communityFormGroup.markAllAsTouched();
      return;
    }

    if (this.communityId) {
      this.editCommunity();
    } else {
      this.addCommunity();
    }
  }

  addCommunity() {
    const communityPayload = this.payloadWithFormattedDate();
    this.communityService.addCommunity(communityPayload).subscribe(
      (response) => {
        this.showAlertBox(true, 'تم إضافة المجتمع بنجاح');
        const communityId = response?.data?.id;
        this.router.navigate(['pages/community/community-details', communityId], {replaceUrl: true});
      },
      (error) => {
        this.showAlertBox(false, extractErrorMessage(error, 'حدث خطأ أثناء إضافة المجتمع'));
      }
    );
  }

  editCommunity() {
    const communityPayload = this.payloadWithFormattedDate();
    if (this.communityId) {
      this.communityService.editCommunity(this.communityId, communityPayload).subscribe(
        (response) => {
          this.showAlertBox(true, 'تم تعديل المجتمع بنجاح');
        },
        (error) => {
          this.showAlertBox(false, extractErrorMessage(error, 'حدث خطأ أثناء تعديل المجتمع'));
        }
      );
    }
  }


  showAlertBox(successImg: boolean, confirmMsg: string) {
    this.saveDialogRef = this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: successImg,
        message: confirmMsg,
        button: 'تم',
      },
    });
  }
}
